@if (!loading && imageItems.length > 0) {
  <div>
    @for (image of imageItems; track image; let imageIndex = $index) {
      <div class="image-tagging-holder">
        <div style="position: relative" class="image-holder">
          <img
            [src]="image.displayUrl"
            alt=""
            (load)="updateImageScale(imageIndex, $event)"
          />
          @for (face of image.faces; track face; let i = $index) {
            <div
              class="face-holder"
              style="display: block; position: absolute; border: 3px solid"
              [style.width]="
                face.coordinates.width * image.scaleFactorWidth + 'px'
              "
              [style.height]="
                face.coordinates.height * image.scaleFactorHeight + 'px'
              "
              [style.left]="
                face.coordinates.xmin * image.scaleFactorWidth + 'px'
              "
              [style.top]="
                face.coordinates.ymin * image.scaleFactorHeight + 'px'
              "
              [style.border-color]="image.faceMeta[i]?.borderColor"
            ></div>
          }
          @for (logo of image.logos; track logo) {
            <div
              class="face-holder"
              style="display: block; position: absolute; border: 3px solid"
              [style.width]="
                logo.coordinates.width * image.scaleFactorWidth + 'px'
              "
              [style.height]="
                logo.coordinates.height * image.scaleFactorHeight + 'px'
              "
              [style.left]="
                logo.coordinates.xmin * image.scaleFactorWidth + 'px'
              "
              [style.top]="
                logo.coordinates.ymin * image.scaleFactorHeight + 'px'
              "
              [style.border-color]="logoBorderColor"
            ></div>
          }
        </div>
        @if (image.faces.length > 0) {
          <div class="detect-title">
            {{
              "post-image-tagging.title.detected-faces-&-recognized-people"
                | translate
            }}
          </div>
        }
        @if (image.faces.length > 0) {
          <div class="faces-holder">
            @for (face of image.faces; track face; let i = $index) {
              <div
                class="face-box"
                [ngClass]="
                  $safeNavigationMigration(image.faceMeta[i]?.recognitionStatus)
                "
              >
                <div class="image-and-name">
                  <div class="face-number">{{ i + 1 }}</div>
                  <img
                    [src]="'data:image/png;base64,' + face.image_bytes"
                    alt=""
                    style="border: 3px solid"
                    [style.border-color]="image.faceMeta[i]?.borderColor"
                  />
                  <div class="input-holder">
                    <input
                      type="text"
                      placeholder="Start typing for suggestions"
                      [value]="
                        $safeNavigationMigration(image.faceMeta[i]?.name)
                      "
                      (input)="inputChange($event.target, imageIndex, i)"
                    />
                    @if (image.faceMeta[i]?.expandList) {
                      <ul>
                        @for (suggestion of suggestList; track suggestion) {
                          <li (click)="handleNameClick($event, imageIndex, i)">
                            {{ suggestion.name }}
                          </li>
                        }
                      </ul>
                    }
                  </div>
                </div>
                <a
                  class="google"
                  href="https://www.google.com/search?q=%22{{
                    image.faceMeta[i]?.name || face.person_name
                  }}%22"
                  target="_blank"
                >
                  <fa-icon [icon]="['fab', 'google']"></fa-icon>
                </a>
                <div class="status-buttons">
                  <div
                    class="btn-recognized"
                    [class.disabled]="image.faceMeta[i]?.name === ''"
                    (click)="setStatus(imageIndex, i, 3)"
                  >
                    Recognized
                  </div>
                  <div
                    class="btn-unrecognized"
                    (click)="setStatus(imageIndex, i, 1)"
                  >
                    Unrecognized
                  </div>
                  <div
                    class="btn-ignored"
                    (click)="setStatus(imageIndex, i, 2)"
                  >
                    Ignored
                  </div>
                </div>
                <div class="btn-save" (click)="save(imageIndex, i)">
                  <fa-icon [icon]="['fas', 'floppy-disk']"></fa-icon>
                </div>
              </div>
            }
          </div>
        }
        @if (image.logos.length > 0) {
          <div class="detect-title">Detected Logos</div>
        }
        @if (image.logos.length > 0) {
          <div class="faces-holder">
            @for (logo of image.logos; track logo; let i = $index) {
              <div class="face-box logo-box">
                <div class="image-and-name">
                  <div class="face-number">{{ i + 1 }}</div>
                  @if (logo.image_bytes) {
                    <img
                      [src]="'data:image/png;base64,' + logo.image_bytes"
                      alt=""
                      style="border: 3px solid"
                      [style.border-color]="logoBorderColor"
                    />
                  }
                  @if (!logo.image_bytes) {
                    <div class="logo-placeholder"></div>
                  }
                  @if (!logo.brand) {
                    <div class="input-holder">
                      <input
                        type="text"
                        placeholder="Start typing for suggestions"
                        [value]="image.logoMeta[i]?.name || ''"
                        (input)="logoInputChange($event.target, imageIndex, i)"
                      />
                      @if (
                        image.logoMeta[i]?.expandList ||
                        logo.suggestions?.length > 0
                      ) {
                        <ul>
                          @for (
                            suggestion of logo.suggestions;
                            track suggestion
                          ) {
                            <li
                              (click)="
                                handleLogoNameClick($event, imageIndex, i)
                              "
                            >
                              {{ suggestion.brand }}
                            </li>
                          }
                        </ul>
                      }
                    </div>
                  }
                  @if (logo.brand) {
                    <div class="logo-meta">
                      <div class="logo-name">
                        {{ image.logoMeta[i]?.name || logo.brand }}
                      </div>
                      <div class="logo-confidence">
                        {{ logo.confidence | number: "1.0-2" }}
                      </div>
                    </div>
                  }
                </div>
                <a
                  class="google"
                  [class.enabled]="image.logoMeta[i]?.name || logo.brand"
                  href="https://www.google.com/search?q=%22{{
                    image.logoMeta[i]?.name || logo.brand
                  }}%22"
                  target="_blank"
                >
                  <fa-icon [icon]="['fab', 'google']"></fa-icon>
                </a>
                <div class="btn-save" (click)="saveLogo(imageIndex, i)">
                  <fa-icon [icon]="['fas', 'floppy-disk']"></fa-icon>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
@if (loading) {
  <div>
    <app-loading></app-loading>
  </div>
}
@if (!loading && !hasDetections) {
  <div class="no-data">
    <p>No faces or logos recognized</p>
  </div>
}
